import React from 'react';

import AdminActivityPage from './AdminActivityPage';

const AdminGroupOneActivityPage: React.FC = () => (
  <AdminActivityPage groupId="1" title="Group 1 User Activity" />
);

export default AdminGroupOneActivityPage;
